
    
    <mat-card class="filter">

      <label>My Drive </label>

      <div class="view_list">
        <button mat-icon-button [ngClass]="{ active: showList }"
          mat-icon-button (click)="showListopt()">
          <mat-icon>format_list_bulleted</mat-icon>
        </button>
        <button mat-icon-button [ngClass]="{ active: showGrid }" (click)="showGridopt()">
          <mat-icon >apps</mat-icon>
        </button>
      </div>

       

        <button mat-icon-button [matMenuTriggerFor]="menus1" color="primary">
          <mat-icon>folder</mat-icon>
        </button>
        <mat-menu #menus1="matMenu" xPosition="after">
          <ng-container *ngFor="let item of fileManagerFolderReportList">
          <button mat-menu-item (click)="GetDocumentsbyType(item)">
            <mat-icon>picture_as_pdf</mat-icon> {{item.folderName}}
          </button>     
        </ng-container>    
        </mat-menu>
    

        <div class="projectSearch">
      
          <button class="searchbtn" [disabled]="searchKey == ''"  mat-icon-button aria-label="Clear">
            <mat-icon (click)="SearchFilter()">search</mat-icon>
          </button>
         
          <input placeholder="Search File & Folder..." type="text"  maxlength="30" [(ngModel)]="searchKey" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" />
         
          <button class="filterbtn" mat-icon-button (click)="applyAdvFilter(advFilter)"
          matTooltipClass="tooltip" matTooltip="Filters">
         <mat-icon>filter_list</mat-icon>
        </button>
       
  
       </div>
      <!-- <mat-form-field appearance="">
        <mat-label>Search File & Folder... </mat-label>
        <input matInput type="text" [(ngModel)]="searchKey" (keyup)="$event.keyCode == 13
              ? Search($event.target.value)
              : $event.target.value == ''
              ? Search($event.target.value)
              : null" />
        <button [disabled]="searchKey == ''" matSuffix mat-icon-button aria-label="Clear">
           <mat-icon (click)="SearchFilter()">search</mat-icon>
        </button>   
      </mat-form-field>

      <button class="filterList" mat-icon-button (click)="applyAdvFilter(advFilter)"
        matTooltipClass="tooltip" matTooltip="Filters">
       <mat-icon>filter_list</mat-icon>
      </button> -->

      <button *ngIf="subFolderID>0 || isAdvFilter==true" class="viewBtn" mat-icon-button 
        (click)="customizeColumn(customize)" matTooltipClass="tooltip"
         matTooltip="Customize Column">
         <mat-icon>view_column</mat-icon>
      </button>

      <div class="sortview" *ngIf="selectedRecordDeleteArray.length!=0" >
        Items  <span class="count">{{ selectedRecordDeleteArray.length }}</span>
      </div>
      <div class="slAct">
        <ng-container *ngIf="showFavDeletePanel">

          <button mat-button color="primary"  title="Only selected document will be send to PointClickCare" 
          *ngIf="ShowRequestButton && ShowPointClickCare==true" (click)="GetDocumentCategory(documentCategory)">
           <img  style="height: 22px;margin-right: 6px;"
           class="payCheckIcon"
           src="../../../../assets/icons/pccfavicon-32x32.png"/>
           Upload
         </button>

          <button mat-button color="primary" title="Send documents to 3c" (click)="SendDocumentFiles(shareFile)" *ngIf="ShowRequestButton">
            <mat-icon>file_open</mat-icon>Share
          </button>

          <button mat-button color="primary" title="Only selected document will be send to fax" (click)="FaxFiles(shareFile)" *ngIf="ShowRequestButton">
            <mat-icon>assignment</mat-icon> Fax
          </button>
          
          <button mat-button color="primary" title="Only selected document will be send to email" (click)="EmailFiles(shareFile)" *ngIf="ShowRequestButton">
            <mat-icon>email</mat-icon> Email
          </button>

          <button mat-button color="primary" (click)="DeleteSelecteOrAllFolders()">
            <mat-icon>delete_outline</mat-icon> Delete
          </button>
         
          <button mat-button color="primary" (click)="MoveToMutilple()">
            <mat-icon>low_priority</mat-icon> Move to
          </button>
        </ng-container>
      </div>  
         
      
      <div class="add" *ngIf="isShowForm">
        <button class="create" [matMenuTriggerFor]="menu" mat-flat-button color="primary">
          Add Folder/File
        </button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button mat-menu-item (click)="openCreateFolderDialogue(createFileManagerFolder)">
            <mat-icon>folder</mat-icon> New Folder
          </button>
          <input #Input hidden="true" type="file" multiple (change)="selectFilesFromDragZone($event, fileInput)">
          <button mat-menu-item (click)="Input.click()">            
            <mat-icon>upload_file</mat-icon> Upload File
          </button>

          <!-- <button mat-menu-item (click)="openDrive()">           
            <img  style="height: 20px;margin-right: 6px;"              
            src="../../../../assets/icons/GoogleDrive.png"/> 
            Import From Google Drive
          </button> -->

          <!-- <img  style="height: 20px;margin-right: 6px;"              
              src="../../../../assets/icons/GoogleDrive.png"/> 
              Import From Google Drive -->

        </mat-menu>
      </div>


    </mat-card>

   
    <div class="upDoc">
      <div class="uploadholder">
        <input #fileInput type="file" multiple (change)="selectFilesFromDragZone($event, fileInput)"/>
        <!-- <input #Input type="file" multiple (change)="selectFilesFromDragZone($event)"/> -->
        <div class="textIn">
          <p>Drag and drop files here </p>       
        </div>
      </div>
    </div>
   

  <div class="folders" *ngIf="showLocalPanel">
    <div class="heading">
      <span>Quick Access</span>
    </div>

    <div class="allfolder">
      <mat-card class="folder">        
        <div class="iconUser">
          <div class="docType">
            <mat-icon>folder</mat-icon>           
          </div>
          <h4>Core</h4> 

          <div class="countshare">
            <div class="userlist">
              <button mat-icon-button color="primary">
              <mat-icon>share</mat-icon>
            </button>
              <div class="userCount"  matTooltipClass="tooltip">
                2
              </div>
            </div>
            
          </div>

        </div>
      </mat-card>
      <mat-card class="folder">
        
        <div class="iconUser">
          <div class="docType">
            <mat-icon>folder</mat-icon>           
          </div>
          <h4>Agreement</h4> 

          <div class="countshare">
            <div class="userlist">
              <button mat-icon-button color="primary">
              <mat-icon>share</mat-icon>
            </button>
              <div class="userCount"  matTooltipClass="tooltip">
                2
              </div>
            </div>
            
          </div>

        </div>
      </mat-card>
      <mat-card class="folder">
        
        <div class="iconUser">
          <div class="docType">
            <mat-icon>folder</mat-icon>           
          </div>
          <h4>Hospitals</h4> 

          <div class="countshare">
            <div class="userlist">
              <button mat-icon-button color="primary">
              <mat-icon>share</mat-icon>
            </button>
              <div class="userCount"  matTooltipClass="tooltip">
                2
              </div>
            </div>
            
          </div>

        </div>
      </mat-card>
      <mat-card class="folder">
        
        <div class="iconUser">
          <div class="docType">
            <mat-icon>folder</mat-icon>           
          </div>
          <h4>Documents</h4> 

          <div class="countshare">
            <div class="userlist">
              <button mat-icon-button color="primary">
              <mat-icon>share</mat-icon>
            </button>
              <div class="userCount"  matTooltipClass="tooltip">
                2
              </div>
            </div>
            
          </div>

        </div>
      </mat-card>
    </div>
  </div>

   <!-- For My Drive  -->
  <ng-container *ngIf="isShowForm">

  <div class="breadcumb">
    <span (click)="breadCrumbMainClick()">My Drive</span>    

    <span *ngFor="let menu of menuHeader;let i= index;">
      <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
      <a (click)="breadCrumb(menuHeader,i)">{{menu.label}}</a>
      </span>      

     <span class="" *ngIf="menuHeader.length > 0 ">
      <button mat-icon-button class="createNew" color="primary" (click)="openCreateFolderDialogue(createFileManagerFolder)" >
        <mat-icon>create_new_folder</mat-icon>
      </button>
    </span>
    <div class="viewOpt">
      <mat-slide-toggle color="primary" (change)="showOnlyDocs($event)">Show Only Docs</mat-slide-toggle>
    </div>
  </div>


  <mat-card class="grid" *ngIf="!showList">
    <ul>
      <li *ngFor="let folder of foldersList" class="gridItem">
        <div class="gridblock">
          <div class="opicon" >
            <div class="opts">
              <mat-checkbox  color="primary"
                        (change)="isAllSelectedRow($event, folder)"
                        (change)="$event ? selection.toggle(folder) : null"
                        [checked]="selection.isSelected(folder)">
                      </mat-checkbox>
                      <button (click)="addContactOrRole(folder)" mat-icon-button><mat-icon>share</mat-icon></button>                      
                 
                      <div class="act"  *ngIf="folder.name == 'My Projects'">
                        <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #formTypeOpt="matMenu" xPosition="before">                  
                                                
                         <button mat-menu-item *ngIf="folder.isFile == false" (click)="showChildFolders(folder)">
                            <mat-icon>visibility</mat-icon> Details
                          </button>

                          <button mat-menu-item *ngIf="folder.isFile == false" (click)="linkCopy(folder)">
                            <mat-icon>link</mat-icon> Copy URL
                          </button>
                               
                          <button mat-menu-item (click)="addContactOrRole(folder)">
                            <mat-icon>share</mat-icon>Share
                          </button>

                          <button mat-menu-item  *ngIf="folder.isFile == false" (click)="openAITemplate(selectAITemplate,folder,'Folder')">
                            <mat-icon>assessment</mat-icon> AI Template
                          </button>

                        </mat-menu>
                      </div>

                      <div class="act"  *ngIf="folder.name != 'My Projects'">
                        <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #formTypeOpt="matMenu" xPosition="before">                   
                          <button mat-menu-item (click)="renameFileManagerItem(folder)">
                            <mat-icon>format_size</mat-icon> Rename
                          </button>
                          <button mat-menu-item (click)="MoveTo(folder)">
                            <mat-icon>low_priority</mat-icon> Move to
                          </button>
                          <button *ngIf="folder.isFile == false" mat-menu-item (click)="DeleteFolders(folder)">
                            <mat-icon>delete_outline</mat-icon> Delete
                          </button>
        
                          <button *ngIf="folder.isFile == true" mat-menu-item (click)="DeleteFile(folder)">
                            <mat-icon>delete_outline</mat-icon> Delete
                          </button>
        
                         <button mat-menu-item  *ngIf="folder.isFile == false" (click)="showChildFolders(folder)">
                            <mat-icon>visibility</mat-icon> Details
                          </button>
        
                          <button mat-menu-item  *ngIf="folder.isFile == true" (click)="showFileDetails(folder)">
                            <mat-icon>visibility</mat-icon> Details
                          </button>

                          <button mat-menu-item  *ngIf="folder.isFile == false" (click)="linkCopy(folder)">
                            <mat-icon>link</mat-icon> Copy URL
                          </button>

                          <button mat-menu-item (click)="addContactOrRole(folder)">
                            <mat-icon>share</mat-icon>Share
                          </button>

                          <button mat-menu-item  *ngIf="folder.isFile == true" (click)="DownloadSigleFile(folder)">
                            <mat-icon>cloud_download</mat-icon> Download
                          </button>

                          
                          <!-- <button mat-menu-item class="aiBTN"  *ngIf="folder.isFile == true" (click)="openAIBinding(folder)" >
                            <span class="globalAiBtn" >AI</span> Sync Data
                          </button> -->

                          <button mat-menu-item class="aiBTN"  *ngIf="folder.fileType == 'pdf'" (click)="openAITools(folder)" >
                            <span class="globalAiBtn" >AI</span> AI Tool
                          </button>

                          <button mat-menu-item  *ngIf="folder.isFile == true" (click)="linkCopyFiles(folder)">
                            <mat-icon>link</mat-icon> Public Url
                          </button>

                          <button mat-menu-item  *ngIf="folder.isFile == false" (click)="openAITemplate(selectAITemplate,folder,'Folder')">
                            <mat-icon>assessment</mat-icon> AI Template
                          </button>

                        </mat-menu>
                      </div>
            </div>
      
              <div (click)="showChildFolders(folder)" class="mat-cell docType" *ngIf="folder.isFile == false && folder.isShared == false"><mat-icon>folder</mat-icon></div>
              <div (click)="showChildFolders(folder)" class="mat-cell docType" *ngIf="folder.isShared == true && folder.isFile == false"><mat-icon>folder_shared</mat-icon></div>
              <div class="mat-cell formIcon" *ngIf="folder.isFile == true" (click)="openDocumentViewer(true,folder,docViewer)">
               
                <ng-container *ngIf="folder.fileType == 'pdf'">
                  <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />    -->
                  <app-doc-icons  [iconType]="'PDF'"></app-doc-icons>
                </ng-container>
                <ng-container *ngIf="folder.fileType == 'png'">
                  <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/020-png.svg" alt="png File"/> -->
                  <app-doc-icons  [iconType]="'PNG'"></app-doc-icons>
                </ng-container>
                <ng-container *ngIf="folder.fileType == 'jpg'">
                  <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File"/> -->
                  <app-doc-icons  [iconType]="'JPG'"></app-doc-icons>
                </ng-container>  
                <ng-container *ngIf="folder.fileType == 'heic'">
                  <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File"/> -->
                  <app-doc-icons  [iconType]="'HEIC'"></app-doc-icons> 
                </ng-container>                
                <!-- <mat-icon *ngIf="folder.fileType != 'pdf' && folder.fileType != 'png' && folder.fileType != 'jpg'">
                  description
                </mat-icon> -->
                <app-doc-icons *ngIf="folder.fileType != 'heic' && folder.fileType != 'pdf' && folder.fileType != 'png' && folder.fileType != 'jpg'"  [iconType]="'OTHER'"></app-doc-icons>
                
              </div>
          </div>
    
    
          <div class="namedate">
            <p matTooltipClass="tooltip" matTooltip="{{folder.name}}" >{{folder.name}}</p>     
            <!-- <span *ngIf="folder.fileSize" class="fileSize" >{{ folder.fileSize }}</span>-->
            <span>{{folder.createdOn +'Z'|date: "MM/dd/yyyy" }} </span>
          </div>
        </div> 
      </li>
    </ul>
    <ng-container *ngIf="foldersListShow">
      <!-- <tr>
        <td colspan="7"> -->
          <p class="nocontent">No Items Found</p>
        <!-- </td>
      </tr> -->
    </ng-container>
  </mat-card>
 
  <mat-card class="files" *ngIf="showList">
    <table class="mat-table">
      <thead>
        <tr class="mat-header-row">
          <th class="mat-header-cell wfolder">
            <span class="checkbo">
              <span class="checkbo">
                <mat-checkbox color="primary" [disabled]="!foldersList"
                  (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()">
                </mat-checkbox>
                <p></p>
              </span>
            </span>
          </th>

          <th class="mat-header-cell wstar fav" *ngIf="showLocalPanel"></th>
          <th class="mat-header-cell wfolder docType"></th>
          <th class="mat-header-cell">Name</th>
          <th class="mat-header-cell shareIcon">&nbsp;</th>
          <th class="mat-header-cell shareIcon">&nbsp;</th>
          <th class="mat-header-cell pro">AI Process</th>
          <th class="mat-header-cell pro">&nbsp;</th>
          <th class="mat-header-cell pro">Status</th>
          <th class="mat-header-cell date" (click)="sortByCreatedOn()">Created On
            <mat-icon style="margin-top: -10px" *ngIf="sortDirection === 'asc'">arrow_upward</mat-icon>
            <mat-icon style="margin-top: -10px" *ngIf="sortDirection === 'desc'">arrow_downward</mat-icon>
          </th>        
          <th class="mat-header-cell action">Action</th>
          <ng-container *ngIf="subFolderID>0 || isAdvFilter==true">          
            <th class="mat-header-cell date" *ngFor="let clm of showCustomColumninList">
              <span>{{clm.fieldName}}</span>
            </th>             
          </ng-container>
        </tr>
       
      </thead>
      <tbody id="filemanagertbody">
        
          <tr class="mat-row foldericon" *ngFor="let folder of foldersList">
            <td class="mat-cell">
              <span class="checkbo">
                <mat-checkbox  color="primary"
                (change)="isAllSelectedRow($event, folder)"
                (change)="$event ? selection.toggle(folder) : null"
                [checked]="selection.isSelected(folder)">
              </mat-checkbox>
              </span>
            </td>
            <td class="mat-cell" *ngIf="showLocalPanel">
              <mat-icon class="star">grade</mat-icon>
            </td>
            <td (click)="showChildFolders(folder)" class="mat-cell docType" *ngIf="folder.isFile == false && folder.isShared == false"><mat-icon>folder</mat-icon></td>
            <td (click)="showChildFolders(folder)" class="mat-cell docType" *ngIf="folder.isShared == true && folder.isFile == false"><mat-icon>folder_shared</mat-icon></td>
            <td class="mat-cell formIcon" *ngIf="folder.isFile == true" (click)="openDocumentViewer(true,folder,docViewer)">
              <ng-container *ngIf="folder.fileType == 'pdf'">
                <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />                   -->
                <app-doc-icons  [iconType]="'PDF'"></app-doc-icons>
              </ng-container>
              <ng-container *ngIf="folder.fileType == 'png'">
                <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/020-png.svg" alt="png File"/> -->
                <app-doc-icons  [iconType]="'PNG'"></app-doc-icons>
              </ng-container>
              <ng-container *ngIf="folder.fileType == 'jpg'">
                <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File"/> -->
                <app-doc-icons  [iconType]="'JPG'"></app-doc-icons>
              </ng-container>  
              <ng-container *ngIf="folder.fileType == 'heic'">
                <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File"/> -->
                <app-doc-icons  [iconType]="'HEIC'"></app-doc-icons> 
              </ng-container>              
              <!-- <mat-icon *ngIf="folder.fileType != 'pdf' && folder.fileType != 'png' && folder.fileType != 'jpg'">
                description
              </mat-icon> -->
              <app-doc-icons *ngIf="folder.fileType != 'heic' && folder.fileType != 'pdf' && folder.fileType != 'png' && folder.fileType != 'jpg'"  [iconType]="'OTHER'"></app-doc-icons>
            </td>
            <td class="mat-cell" *ngIf="folder.isFile == false" (click)="showChildFolders(folder)">               
              <span class="fldrName" matTooltipClass="tooltip" matTooltip="{{folder.name}}">{{folder.name}}</span>
            </td>
            <td class="mat-cell" *ngIf="folder.isFile == true" (click)="showFileDetails(folder)">   
                <span matTooltipClass="tooltip" class="fldrName" matTooltip="{{folder.name}}" (click)="openDocumentViewer(true,folder,docViewer)">{{folder.name}}</span>                 
                <span *ngIf="folder.fileSize && !isAISearch" class="fileSize" >{{ folder.fileSize }}</span>
                <span *ngIf="folder.text && isAISearch" class="textFile" >{{ folder.text }}</span>
            </td>
            <td class="mat-cell shareIcon">
              <button class="shareFileFol" (click)="addContactOrRole(folder)" mat-icon-button><mat-icon>share</mat-icon></button>
            </td>  
            <td class="mat-cell shareIcon">
              <button class="shareFileFol" *ngIf="folder.fileType == 'pdf' && (folder.aiProcessStatus==0 || folder.aiProcessStatus==2)" (click)="openPanelMergePDF(mergePDFs,folder,'Drive')" mat-icon-button><mat-icon>add_circle</mat-icon></button>
            </td>  
            <td class="mat-cell pro">
              <mat-icon class="processed" matTooltip="{{folder.aiAutomationTemplateName}}" *ngIf="folder.isFile == false && folder.aiAutomationTemplateID>0">assessment</mat-icon>
            </td>
            <td class="mat-cell pro">
              <span class="globalAiBtn" *ngIf="folder.fileType == 'pdf' &&  folder.aiProcessStatus==2" (click)="openAITools(folder)" title="AI Tool">
                AI
              </span>             
            </td>
            <td class="mat-cell pro">             
              <mat-icon class="processed" *ngIf="folder.fileType == 'pdf' && folder.aiProcessStatus==2">check_circle</mat-icon>
              <!-- <mat-icon  *ngIf="folder.fileType == 'pdf' && folder.error!=null" (click)="showAutomationError(folder)">error</mat-icon> -->
              <mat-icon class="notProcessed" *ngIf="folder.fileType == 'pdf' && folder.aiProcessStatus==2" (click)="ReRunAutomationForAITool(folder)" matTooltip="Rerun">autorenew</mat-icon>
              <mat-icon  class="notProcessed" *ngIf="folder.fileType == 'pdf' && folder.aiProcessStatus==0" (click)="openAITemplate(selectAITemplate,folder,'File')">restore_page</mat-icon>
              
              <!-- <mat-spinner style="margin: auto" *ngIf="folder.fileType == 'pdf' && folder.aiProcessStatus==1" diameter="20"></mat-spinner> -->
             
              <div class="aiIcon" *ngIf="folder.fileType == 'pdf' && folder.aiProcessStatus==1">
                <div class="ai-processing" >
                <div class="brain-icon">🧠­</div>
                <div class="ai-text">AI</div>
              </div>
              <span>Running</span>
              </div>
              <!-- <mat-icon class="processed" *ngIf="folder.fileType == 'pdf' && folder.vectorFileID">check_circle</mat-icon>
              <mat-icon  class="notProcessed" *ngIf="folder.fileType == 'pdf' && !folder.vectorFileID" (click)="openAITemplate(selectAITemplate,folder,'File')">restore_page</mat-icon>
              -->
              <!-- <button class="shareFileFol" (click)="addContactOrRole(folder)" mat-icon-button><mat-icon>share</mat-icon></button> -->
            </td> 
                    
            <td class="mat-cell date" (click)="showFileDetails(folder)"> {{folder.createdOn +'Z'|date: "MM/dd/yyyy" }}  </td>
            <!-- <td class="mat-cell date" *ngIf="folder.updatedOn!=null" (click)="showFileDetails(folder)">{{folder.updatedOn +'Z'|date: "MM/dd/yyyy" }} </td>
            <td class="mat-cell date" *ngIf="folder.updatedOn==null" (click)="showFileDetails(folder)">{{folder.createdOn +'Z'|date: "MM/dd/yyyy" }} </td> -->
            <td class="mat-cell action">
            
              <div class="act"  *ngIf="folder.name == 'My Projects'">
                <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
                  <mat-icon>more_vertical</mat-icon>
                </button>
                <mat-menu #formTypeOpt="matMenu" xPosition="before">                  

                 <button mat-menu-item  *ngIf="folder.isFile == false" (click)="showChildFolders(folder)">
                    <mat-icon>visibility</mat-icon> Details
                  </button> 

                  <button mat-menu-item  *ngIf="folder.isFile == false" (click)="linkCopy(folder)">
                    <mat-icon>link</mat-icon> Public Url
                  </button>

                  <button mat-menu-item  *ngIf="folder.isFile == false" (click)="openAITemplate(selectAITemplate,folder,'Folder')">
                    <mat-icon>assessment</mat-icon> AI Template
                  </button>

                  <button mat-menu-item (click)="addContactOrRole(folder)">
                    <mat-icon>share</mat-icon>Share
                  </button>

                </mat-menu>
              </div>

              <div class="act"  *ngIf="folder.name != 'My Projects'">
                <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
                  <mat-icon>more_vertical</mat-icon>
                </button>
                <mat-menu #formTypeOpt="matMenu" xPosition="before">                   
                  <button mat-menu-item (click)="renameFileManagerItem(folder)">
                    <mat-icon>format_size</mat-icon> Rename
                  </button>
                  <button mat-menu-item (click)="MoveTo(folder)">
                    <mat-icon>low_priority</mat-icon> Move to
                  </button>
                  <button *ngIf="folder.isFile == false" mat-menu-item (click)="DeleteFolders(folder)">
                    <mat-icon>delete_outline</mat-icon> Delete
                  </button>

                  <button *ngIf="folder.isFile == true" mat-menu-item (click)="DeleteFile(folder)">
                    <mat-icon>delete_outline</mat-icon> Delete
                  </button>

                 <button mat-menu-item  *ngIf="folder.isFile == false" (click)="showChildFolders(folder)">
                    <mat-icon>visibility</mat-icon> Details
                  </button>

                  <button mat-menu-item  *ngIf="folder.isFile == true" (click)="showFileDetails(folder)">
                    <mat-icon>visibility</mat-icon> Details
                  </button>                 

                  <button mat-menu-item  *ngIf="folder.isFile == false" (click)="linkCopy(folder)">
                    <mat-icon>link</mat-icon> Public Url
                  </button>
                  
                  <button mat-menu-item  *ngIf="folder.isFile == false" (click)="openAITemplate(selectAITemplate,folder,'Folder')">
                    <mat-icon>assessment</mat-icon> AI Template
                  </button>

                  <button mat-menu-item (click)="addContactOrRole(folder)">
                    <mat-icon>share</mat-icon>Share
                  </button>
                  <button *ngIf="folder.isFile == false" mat-menu-item (click)="selectIcon(folder)">
                    <mat-icon>add</mat-icon>Dashboard Quick Link
                  </button>

                  <button mat-menu-item  *ngIf="folder.isFile == true" (click)="DownloadSigleFile(folder)">
                    <mat-icon>cloud_download</mat-icon> Download
                  </button>

                  <!-- <button mat-menu-item  class="aiBTN" *ngIf="folder.isFile == true" (click)="openAIBinding(folder)">
                    <span class="globalAiBtn" >AI</span>  Sync Data
                  </button> -->

                  <!-- <button mat-menu-item class="aiBTN"  *ngIf="folder.fileType == 'pdf' && folder.aiProcessStatus==2" (click)="openAITools(folder)" >
                    <span class="globalAiBtn" >AI</span> AI Tool
                  </button> -->

                   <button mat-menu-item class="aiBTN"  *ngIf="folder.fileType == 'pdf'" (click)="openAITools(folder)" >
                    <span class="globalAiBtn" >AI</span> AI Tool
                  </button>
                  
                  <button mat-menu-item  *ngIf="folder.isFile == true" (click)="linkCopyFiles(folder)">
                    <mat-icon>link</mat-icon> Public Url
                  </button>

                </mat-menu>
              </div>
            </td>

            <ng-container *ngIf="subFolderID>0 || isAdvFilter==true">
              <td class="mat-cell date" *ngFor="let rowdata of showCustomColumninList;">                
                <p (click)="showFileDetails(folder)"> {{ getFieldColumnValues(rowdata,folder) }}</p>
              </td>
            </ng-container>

          </tr>
      

        <ng-container *ngIf="foldersListShow">
          <tr>
            <td colspan="7">
              <p class="nocontent">No Items Found</p>
            </td>
          </tr>
        </ng-container>

    
      </tbody>
    </table>

 
  </mat-card>

  <mat-paginator *ngIf="!foldersListShow" [length]="paginatorTotalLength" 
  [pageIndex]="pageIndex-1" [pageSize]="pageSize" [pageSizeOptions]="['All',10, 20, 30]"
  itemsPerPageLabel="Records Per Page" showFirstLastButtons
  (page)="pageEventPropogate($event)">
  </mat-paginator>
  </ng-container>

   <!-- For Shared With Me  -->
  <ng-container *ngIf="isSharedWithMe">

  <div class="breadcumb">
    <span (click)="breadCrumbMainSHaredWithMeClick()">Shared with me</span>

    <span *ngFor="let menu of menuHeader;let i= index;">
      <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
      <a (click)="breadCrumbShareWithMe(menuHeader,i)">{{menu.label}}</a>
      </span>
    </div>


  <mat-card class="grid" *ngIf="!showList">
    <ul>
      <li *ngFor="let folder of SharedWithMeFormFolderList" class="gridItem">
     <div class="gridblock">
      <div class="opicon">
        <div class="opts">
          <mat-checkbox  color="primary" disabled="true"
               (change)="isAllSelectedRow($event, folder)"
               (change)="$event ? selection.toggle(folder) : null"
                [checked]="selection.isSelected(folder)">
          </mat-checkbox>
          <div class="act" >
            <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #formTypeOpt="matMenu" xPosition="before">                   
              <button mat-menu-item (click)="showChildFoldersSharedWithMe(folder)">
                <mat-icon>visibility</mat-icon> Details
              </button>

              <button mat-menu-item  *ngIf="folder.permissionType == 1" (click)="renameFileManagerItemSharedWithMe(folder)">
                    <mat-icon>format_size</mat-icon> Rename
                </button>
                            
               
                <button *ngIf="folder.permissionType == 1 && folder.isFile == false" mat-menu-item (click)="DeleteFoldersSharedWithMe(folder)">
                  <mat-icon>delete_outline</mat-icon> Delete
                </button>

                <button *ngIf="folder.permissionType == 1 && folder.isFile == true" mat-menu-item (click)="DeleteFileSharedWithMe(folder)">
                  <mat-icon>delete_outline</mat-icon> Delete
                </button>

                <button mat-menu-item  *ngIf="folder.permissionType == 1 && folder.isFile == true" (click)="DownloadSigleFileSharedWithMe(folder)">
                    <mat-icon>cloud_download</mat-icon> Download
                </button>
                  
                  <!-- <button mat-menu-item class="aiBTN"  *ngIf="folder.permissionType == 1 && folder.isFile == true" (click)="openAIBindingSharedWithMe(folder)" >
                   <span class="globalAiBtn" >AI</span> Sync Data
                  </button> -->
                  
                  <button mat-menu-item class="aiBTN"  *ngIf="folder.permissionType == 1 && folder.fileType == 'pdf'" (click)="openAIToolsSharedWithMe(folder)" >
                   <span class="globalAiBtn" >AI</span> AI Tool
                  </button>
                  
                  <button mat-menu-item  *ngIf="folder.permissionType == 1 && folder.isFile == false" (click)="linkCopy(folder)">
                    <mat-icon>link</mat-icon> Public Url
                  </button>

                  <button mat-menu-item  *ngIf="folder.permissionType == 1 && folder.isFile == true" (click)="linkCopyFiles(folder)">
                   <mat-icon>link</mat-icon> Public Url
                  </button>
                 
                  <button mat-menu-item  *ngIf="folder.permissionType == 1 && folder.isFile == false" (click)="openAITemplateSharedWithMe(selectAITemplate,folder,'Folder')">
                    <mat-icon>assessment</mat-icon> AI Template
                  </button>

            </mat-menu>
          </div>
        </div>
  
          <div (click)="showChildFoldersSharedWithMe(folder)" class="mat-cell docType" *ngIf="folder.isFile == false"><mat-icon>folder</mat-icon></div>
          <div class="mat-cell formIcon" *ngIf="folder.isFile == true"  (click)="openDocumentViewerSharedWithMe(true,folder,docViewer)">
            <ng-container *ngIf="folder.fileType == 'pdf'">
              <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File"/> -->
              <app-doc-icons  [iconType]="'PDF'"></app-doc-icons>              
            </ng-container>
            <ng-container *ngIf="folder.fileType == 'png'">
              <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/020-png.svg" alt="png File"/>-->
              <app-doc-icons  [iconType]="'PNG'"></app-doc-icons> 
            </ng-container>
            <ng-container *ngIf="folder.fileType == 'jpg'">
              <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File"/> -->
              <app-doc-icons  [iconType]="'JPG'"></app-doc-icons> 
            </ng-container>  
            <ng-container *ngIf="folder.fileType == 'heic'">
              <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File"/> -->
              <app-doc-icons  [iconType]="'HEIC'"></app-doc-icons> 
            </ng-container>               
            <!-- <mat-icon *ngIf="folder.fileType != 'pdf' && folder.fileType != 'png' && folder.fileType != 'jpg'">
              description
            </mat-icon> -->
            <app-doc-icons  *ngIf="folder.fileType != 'heic' && folder.fileType != 'pdf' && folder.fileType != 'png' && folder.fileType != 'jpg'" [iconType]="'OTHER'"></app-doc-icons> 
          </div>

      </div>


      <div class="namedate" >
        <p matTooltipClass="tooltip" matTooltip="{{folder.name}}" >{{folder.name}}</p>
      <span>{{folder.createdOn +'Z'|date: "MM/dd/yyyy" }} </span>
      <ng-container *ngIf="parentId==0">
        <p class="formName" matTooltipClass="tooltip">
          By: {{ folder.sharedbyFirstName }}  {{ folder.sharedbyLastName }}
        </p>
      </ng-container> 
      </div>
      
     </div>

      </li>
        <ng-container *ngIf="SharedWithMeFormFolderList.length==0">
              <p class="nocontent">No Items Found</p>
        </ng-container>  
    </ul>
  </mat-card>
 
  <mat-card class="files" *ngIf="showList">
    <table class="mat-table">
      <thead>
        <tr class="mat-header-row">
          <th class="mat-header-cell wfolder">
            <span class="checkbo">
              <span class="checkbo">
                <mat-checkbox color="primary" disabled="true"
                  (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()">
                </mat-checkbox>
                <p></p>
              </span>
            </span>
          </th>
         
          <th class="mat-header-cell wfolder docType"></th>
          <th class="mat-header-cell">Name</th>
          <th class="mat-header-cell pro">AI Process</th>
          <th class="mat-header-cell pro">&nbsp;</th>
          <th class="mat-header-cell pro">&nbsp;</th>
          <th class="mat-header-cell pro">Status</th>
          <th class="mat-header-cell" *ngIf="parentId==0">Shared By</th>
          <th class="mat-header-cell date" (click)="sortByCreatedOnSharedWithMe()">Created On
            <mat-icon style="margin-top: -10px" *ngIf="sortDirection === 'asc'">arrow_upward</mat-icon>
            <mat-icon style="margin-top: -10px" *ngIf="sortDirection === 'desc'">arrow_downward</mat-icon>
          </th>  
          <th class="mat-header-cell date">Modified On</th>
          <th class="mat-header-cell action">Action</th>
        </tr>
      </thead>
      <tbody>
        
          <tr class="mat-row foldericon" *ngFor="let folder of SharedWithMeFormFolderList">
            <td class="mat-cell">
              <span class="checkbo">
                <mat-checkbox  color="primary"  *ngIf="folder.permissionType == 1"
                (change)="isAllSelectedRow($event, folder)" disabled="true"
                (change)="$event ? selection.toggle(folder) : null"
                [checked]="selection.isSelected(folder)">
              </mat-checkbox>
              <mat-checkbox *ngIf="folder.permissionType == 0" disabled="true"
               color="primary" [checked]="selection.isSelected(folder)">
              </mat-checkbox>
              </span>
            </td>
           
            <td class="mat-cell docType" *ngIf="folder.isFile == false"><mat-icon>folder</mat-icon></td>
            <td class="mat-cell formIcon" *ngIf="folder.isFile == true">
              <ng-container *ngIf="folder.fileType == 'pdf'">
                <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />                   -->
                <app-doc-icons  [iconType]="'PDF'"></app-doc-icons> 
              </ng-container>
              <ng-container *ngIf="folder.fileType == 'png'">
                <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/020-png.svg" alt="png File"/> -->
                <app-doc-icons  [iconType]="'PNG'"></app-doc-icons> 
              </ng-container>
              <ng-container *ngIf="folder.fileType == 'jpg'">
                <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File"/> -->
                <app-doc-icons  [iconType]="'JPG'"></app-doc-icons> 
              </ng-container>
              <ng-container *ngIf="folder.fileType == 'heic'">
                <!-- <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File"/> -->
                <app-doc-icons  [iconType]="'HEIC'"></app-doc-icons> 
              </ng-container>                
              <!-- <mat-icon *ngIf="folder.fileType != 'pdf' && folder.fileType != 'png' && folder.fileType != 'jpg'">
                description
              </mat-icon> -->
              <app-doc-icons  *ngIf="folder.fileType != 'heic' && folder.fileType != 'pdf' && folder.fileType != 'png' && folder.fileType != 'jpg'" [iconType]="'OTHER'"></app-doc-icons> 
            </td>
            <td class="mat-cell" *ngIf="folder.isFile == false" (click)="showChildFoldersSharedWithMe(folder)">               
              <span class="fldrName" matTooltipClass="tooltip" matTooltip="{{folder.name}}">{{folder.name}}</span>
            </td>
            <td class="mat-cell" *ngIf="folder.isFile == true" (click)="showFileDetailsSharedWithMe(folder)">   
                <span matTooltipClass="tooltip" class="fldrName" matTooltip="{{folder.name}}" (click)="openDocumentViewerSharedWithMe(true,folder,docViewer)">{{folder.name}}</span>                 
            </td>
            <td class="mat-cell pro">
              <button class="shareFileFol" *ngIf="folder.permissionType == 1 && folder.fileType == 'pdf'" (click)="openPanelMergePDF(mergePDFs,folder,'SharedWimMe')" mat-icon-button><mat-icon>add_circle</mat-icon></button>
            </td>
            <td class="mat-cell pro">
              <mat-icon class="processed" matTooltip="{{folder.aiAutomationTemplateName}}" *ngIf="folder.permissionType == 1 && folder.isFile == false && folder.aiAutomationTemplateID>0">assessment</mat-icon>
            </td>
           
            <td class="mat-cell pro">
              <span class="globalAiBtn" *ngIf="folder.permissionType == 1 && folder.fileType == 'pdf' && folder.aiProcessStatus==2" (click)="openAIToolsSharedWithMe(folder)" title="AI Tool">
                AI
              </span>             
            </td>

            <td class="mat-cell pro">              
              <mat-icon class="processed" *ngIf="folder.permissionType == 1 && folder.fileType == 'pdf' && folder.aiProcessStatus==2">check_circle</mat-icon>
              <!-- <mat-icon  *ngIf="folder.permissionType == 1 && folder.fileType == 'pdf' && folder.error!=null" (click)="showAutomationError(folder)">error</mat-icon> -->
              <mat-icon class="notProcessed" *ngIf="folder.permissionType == 1 && folder.fileType == 'pdf' && folder.aiProcessStatus==2" (click)="ReRunAutomationForAIToolSharedWithMe(folder)" matTooltip="Rerun">autorenew</mat-icon>
              <mat-icon  class="notProcessed" *ngIf="folder.permissionType == 1 && folder.fileType == 'pdf' && folder.aiProcessStatus==0" (click)="openAITemplateSharedWithMe(selectAITemplate,folder,'File')">restore_page</mat-icon>
              <!-- <mat-spinner style="margin: auto" *ngIf="folder.permissionType == 1 && folder.fileType == 'pdf' && folder.aiProcessStatus==1" diameter="20"></mat-spinner> -->

              <div class="aiIcon" *ngIf="folder.permissionType == 1 && folder.fileType == 'pdf' && folder.aiProcessStatus==1">
                <div class="ai-processing" >
                <div class="brain-icon">🧠­</div>
                <div class="ai-text">AI</div>
              </div>
              <span>Running</span>
              </div>
            </td> 

            <td class="mat-cell" *ngIf="parentId==0">
              <span class="formName" matTooltipClass="tooltip">
                {{ folder.sharedbyFirstName }}  {{ folder.sharedbyLastName }}
              </span>
            </td> 
            <td class="mat-cell date"> {{folder.createdOn +'Z'|date: "MM/dd/yyyy" }}  </td>
            <td class="mat-cell date" *ngIf="folder.updatedOn!=null">{{folder.updatedOn +'Z'|date: "MM/dd/yyyy" }} </td>
            <td class="mat-cell date" *ngIf="folder.updatedOn==null">{{folder.createdOn +'Z'|date: "MM/dd/yyyy" }} </td>
            <td class="mat-cell action">
              <div class="act" >
                <button mat-icon-button [matMenuTriggerFor]="formTypeOpt">
                  <mat-icon>more_vertical</mat-icon>
                </button>
                <mat-menu #formTypeOpt="matMenu" xPosition="before">                   
                  <button mat-menu-item (click)="showChildFoldersSharedWithMe(folder)">
                    <mat-icon>visibility</mat-icon> Details
                  </button>

                  <button mat-menu-item  *ngIf="folder.permissionType == 1" (click)="renameFileManagerItemSharedWithMe(folder)">
                    <mat-icon>format_size</mat-icon> Rename
                  </button>
                            
               
                <button *ngIf="folder.permissionType == 1 && folder.isFile == false" mat-menu-item (click)="DeleteFoldersSharedWithMe(folder)">
                  <mat-icon>delete_outline</mat-icon> Delete
                </button>

                <button *ngIf="folder.permissionType == 1 && folder.isFile == true" mat-menu-item (click)="DeleteFileSharedWithMe(folder)">
                  <mat-icon>delete_outline</mat-icon> Delete
                </button>

                <button mat-menu-item  *ngIf="folder.permissionType == 1 && folder.isFile == true" (click)="DownloadSigleFileSharedWithMe(folder)">
                    <mat-icon>cloud_download</mat-icon> Download
                </button>
                  
                  <!-- <button mat-menu-item class="aiBTN"  *ngIf="folder.permissionType == 1 && folder.isFile == true" (click)="openAIBindingSharedWithMe(folder)" >
                   <span class="globalAiBtn" >AI</span> Sync Data
                  </button> -->
                  
                  <button mat-menu-item class="aiBTN"  *ngIf="folder.permissionType == 1 && folder.fileType == 'pdf'" (click)="openAIToolsSharedWithMe(folder)" >
                   <span class="globalAiBtn" >AI</span> AI Tool
                  </button>
                  
                  <button mat-menu-item  *ngIf="folder.permissionType == 1 && folder.isFile == false" (click)="linkCopy(folder)">
                    <mat-icon>link</mat-icon> Public Url
                  </button>
                  
                  <button mat-menu-item  *ngIf="folder.permissionType == 1 && folder.isFile == true" (click)="linkCopyFiles(folder)">
                    <mat-icon>link</mat-icon> Public Url
                   </button>
                  
                   <button mat-menu-item  *ngIf="folder.permissionType == 1 && folder.isFile == false" (click)="openAITemplateSharedWithMe(selectAITemplate,folder,'Folder')">
                     <mat-icon>assessment</mat-icon> AI Template
                   </button>
                   <button *ngIf="folder.isFile == false"  mat-menu-item (click)="selectIcon(folder)">
                    <mat-icon>add</mat-icon>Dashboard Quick Link
                  </button>
                  
                </mat-menu>
              </div>
            </td>
          </tr>
      

        <ng-container *ngIf="SharedWithMeFormFolderList.length==0">
          <tr>
            <td colspan="7">
              <p class="nocontent">No Items Found</p>
            </td>
          </tr>
        </ng-container>    
      </tbody>
    </table>
 
  </mat-card>

  <!-- <mat-paginator *ngIf="!foldersListShow" [length]="paginatorTotalLength" 
  [pageIndex]="pageIndex-1" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 30]"
  itemsPerPageLabel="Records Per Page" showFirstLastButtons
  (page)="pageEventPropogate($event)">
  </mat-paginator> -->
  </ng-container>
    
  <ng-template #createFileManagerFolder>
  <form  [formGroup]="formDialog">
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
      Create Folder            
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>      
    </h2>    
    
  <mat-dialog-content class="mat-typography">
    <mat-form-field class="example-full-width">
        <mat-label>Folder Name</mat-label>
        <input matInput [required]="true" (keypress)="kypresed($event,formDialog.value)" maxlength="50" placeholder="Add folder name" formControlName="filemanagerFolderName"/>
        <mat-error
        *ngIf="
          formDialog.get('filemanagerFolderName').invalid &&
          (formDialog.get('filemanagerFolderName').dirty ||
          formDialog.get('filemanagerFolderName').touched)">
        <span>This field is mandatory.</span>
      </mat-error>
      </mat-form-field>  
  </mat-dialog-content>
  
  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="close()">Cancel</button>
    <button type="submit" mat-flat-button color="primary" 
    [disabled]="formDialog.invalid || !formDialog.dirty"
    (click)="AddFolderName(formDialog.value)">Create
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
  </mat-dialog-actions>  
    </form>
  </ng-template>
    
  <ng-template #docViewer>
  <app-document-viewer
  (getCloseDocumentViewer)="getCloseDocumentViewer($event)"
  [ngClass]="{ open: documentViewer }"
  [folderID]="folderId"
  [docData]="SelectedDocumentForFileManager">
  </app-document-viewer>
  </ng-template>

  <app-addnew *ngIf="showAddContact"
  (closeAdd)="getCloseAddNew($event)"
  [name]="searchName"  
  [fileManagerItemID]="sendfileManagerItemID"
  [mainModuleName]="mainModuleNameFileManager"
  modulename="{{ modulenameContact }}"
  [ngClass]="{ open: showAddContact }">
  </app-addnew>

  <app-fax-File [mainModuleName]="mainModuleNameFileManager"
    [ngClass]="{ open: showShareFile }"
    (closeShareFile)="getCloseShareFile($event)">
  </app-fax-File>
 
  <app-email-File [mainModuleName]="mainModuleNameFileManager"
  [ngClass]="{ open: showEmailFile }"
  (closeShareFile)="getCloseEmailFile($event)">
  </app-email-File>

  <app-send-document [mainModuleName]="mainModuleNameFileManager"
  [ngClass]="{ open: showShareDocumentIn3c }"
  (closeShareFile3c)="getCloseShareFileFor3C($event)">
</app-send-document>


<app-bind-field-ai *ngIf="openbindFieldsDetail"
[ngClass]="{ open: openbindFieldsDetail }"
(bindFieldViewer)="getAIDetail($event)"
(closeBindEmit)="getCloseBindFieldDetail()"
[folderID]="folderID"
[modulename]="Module"
[mainModulename]="mainModuleNameFileManager"
[transactionID]="transactionIDForTask"
[typeId]="typeIdForTask"
[name]="NameForTask"
[email]="EmailForTask"
[imageUrl]="ImageForTask"
[status]="statusType">
</app-bind-field-ai>

<app-ai-details *ngIf="openAIToolDetail"
[ngClass]="{ open: openAIToolDetail }"
[pdfURL]="azureblobPath"
[documentId]="FileManagerId"
[typeIdCCC]="typeIdForTask"
[documentName]="documentNames"
[docFrom]="docFrom"
[parentIDForAddFiles]="parentIDForAddFiles"
(closeAIToolEmit)="getCloseAIToolDetail()">
</app-ai-details>





<ng-template #customize>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Select the columns you want to display in this list
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <mat-dialog-content class="mat-typography">

    <div class="allheaders">
      <div class="fixrow sep">
        <span>Column Headers</span>
        <span> Active Columns</span>
      </div>

      <ng-container *ngFor="let item of FieldColumnToogle;let i = index">        
        <div class="sep">
          <span>{{item.fieldName}}</span>
          <span>
            <mat-slide-toggle [checked]="item.isDisplay" color="primary" (change)="changedToggle(item,$event)">
            </mat-slide-toggle>           
          </span>
        </div>
      </ng-container>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!SubmitColumnsButton" (click)="onSubmitColumns()">Save</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #advFilter>

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Advanced Search

    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
   
  </h2>

  <div class="">
    <mat-slide-toggle color="primary" [(ngModel)]="isAISearch"
    (change)="enableAIChange($event)">Enable AI Search</mat-slide-toggle>
  </div>

  <mat-dialog-content class="mat-typography">

    <div class="allheaders" *ngIf="isAISearch==false">
      
      <div class="d-flex">

        <div class="w5">
          <mat-form-field class="example-half-width">                
            <mat-label>Document Name</mat-label>
            <input matInput placeholder="File Name" [(ngModel)]="documentName">
        </mat-form-field>
        
        <mat-radio-group color="primary" aria-label="Select an option" (change)="ChangeIsExactDocumentName($event)">
          <mat-radio-button [checked]="true" value="1">Contain</mat-radio-button>
          <mat-radio-button value="2">Exact Match</mat-radio-button>
        </mat-radio-group>
       </div>
    
        <div class="w5">
          <mat-form-field class="example-half-width">                
          <mat-label>Tag/Keyword</mat-label>            
           
          <input matInput type="text" placeholder="Search tag/keyword" 
          (input)="getAllTagsList($event.target.value)" 
          [matAutocomplete]="auto" 
          [(ngModel)]="Tagkeywords">
        
         <mat-autocomplete #auto="matAutocomplete">
          <ng-container *ngFor="let data of allTags">
            <mat-option [value]="data.tagName" (click)="tagSelected(data)">
              {{data.tagName}}
            </mat-option>
          </ng-container>
        </mat-autocomplete> 
        
         </mat-form-field>
         
         <mat-radio-group color="primary" aria-label="Select an option" (change)="ChangeIsExactKeywords($event)">
          <mat-radio-button [checked]="true" value="1">Contain</mat-radio-button>
          <mat-radio-button value="2">Exact Match</mat-radio-button>
         </mat-radio-group>
        </div>

      </div>


      <mat-form-field>
        <mat-label>Author by</mat-label>        
         <mat-select (selectionChange)="authorSelection($event)" [(ngModel)]="authorBy">
          <mat-option *ngFor="let fileType of getAuthorList" [value]="fileType.value">
            {{ fileType.name }}
          </mat-option>
        </mat-select>
       
      </mat-form-field>
       

   <div class="d-flex">
    <div class="w5">

      <mat-form-field class="example-full-width" appearance="">
        <mat-label>Choose from date</mat-label>
        <input matInput [matDatepicker]="picker1" [(ngModel)]="fromDate" readonly>
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
     
    </div>
          
      
    <div class="w5">

      <mat-form-field class="example-full-width" appearance="">
        <mat-label>Choose to date</mat-label>
        <input matInput [matDatepicker]="picker2" 
          [(ngModel)]="toDate" readonly>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
     
    </div>
   </div>

   
  <mat-form-field appearance="">
    <mat-label>File Type</mat-label>
    <mat-select (selectionChange)="fileTypeSelection($event)" [(ngModel)]="fileTypeSelected">
      <mat-option *ngFor="let fileType of fileTypes" [value]="fileType.value">
        {{ fileType.name }}
      </mat-option>
    </mat-select>
  </mat-form-field> 

  <mat-form-field appearance="">
    <mat-label>Content Type</mat-label>
    <mat-select (selectionChange)="onDocumentTypeChange($event)">
      <mat-option *ngFor="let data of fileManagerFolderReportList" [value]="data.subFolderID">
       {{data.folderName}}
     </mat-option>
   </mat-select>
  </mat-form-field> 


   <form [formGroup]="myFormGroup" class="fullw repform">
                    
        
    <ng-container *ngFor="let field of coreUserList">

      <div [ngSwitch]="field.fieldTypeName" class="fullw" *ngIf="field.fieldID > 0">

        <div *ngSwitchCase="'Textbox'">
        
          <mat-form-field *ngIf="field.fieldName != 'Name'">

            <mat-label>{{ field.fieldName }}</mat-label>
            <input [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
              placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
              [readonly]="field.rolePermission==1" />
          </mat-form-field>

        </div>

        <div *ngSwitchCase="'Textarea'">
          <mat-form-field>
            <mat-label>{{ field.fieldName }}</mat-label>
            <textarea [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
              placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
              [readonly]="field.rolePermission==1"></textarea>
          </mat-form-field>
        </div>

        <div *ngSwitchCase="'Number'">
          <mat-form-field>
            <mat-label>{{ field.fieldName }}</mat-label>
            <input [required]='field.isRequired' matInput (keypress)="numberOnly($event)"
              placeholder="{{ field.fieldName }}" [(ngModel)]="field.fieldValue"
              formControlName="{{ field.fieldName }}" [readonly]="field.rolePermission==1" />
          </mat-form-field>
        </div>

        <div *ngSwitchCase="'Currency'">
          <mat-form-field>
            <mat-label>{{ field.fieldName }}</mat-label>
            <input [required]='field.isRequired' matInput placeholder="{{ field.fieldName }}"
              [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
              [readonly]="field.rolePermission==1" />
          </mat-form-field>
        </div>

        <div *ngSwitchCase="'Address'">
          <mat-form-field>
            <mat-label>{{ field.fieldName }}</mat-label>
            <input [required]='field.isRequired' matInput placeholder="{{ field.fieldName }}"
              [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
              [readonly]="field.rolePermission==1" />
          </mat-form-field>
        </div>

        <div *ngSwitchCase="'URL'">
          <mat-form-field>
            <mat-label>{{ field.fieldName }}</mat-label>
            <input [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
              placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
              [readonly]="field.rolePermission==1" />
          </mat-form-field>
        </div>

        <div *ngSwitchCase="'Date'">
          <mat-form-field>
            <mat-label>{{ field.fieldName }}</mat-label>
            <input [required]='field.isRequired' matInput [matDatepicker]="basicDatepicker"
              [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
              [readonly]="field.rolePermission==1" />
              <mat-icon *ngIf="field.fieldValue" matDatepickerToggleIcon class="mat-icon-Cleardate" (click)="clearDate(field)">clear</mat-icon>
            <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #basicDatepicker></mat-datepicker>
          </mat-form-field>
        </div>



        <ng-container *ngSwitchCase="'Dropdown'">          

          <mat-form-field *ngIf="field.fieldName != 'Type'">
            <mat-label>{{ field.fieldName }}</mat-label>
            <mat-select [required]='field.isRequired' [ngModel]="getddlSelectedVal(field.fieldName)"
              formControlName="{{ field.fieldName }}" [disabled]="field.rolePermission==1">
              <mat-option *ngFor="let drp of getdropdownlist(field.fieldName)" [value]="drp">
                {{ drp }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>


        <ng-container *ngSwitchCase="'MultiSelect'">

          <mat-form-field class="example-chip-list" *ngIf="field.fieldName == 'Tags'">
            <mat-label>{{ field.fieldName }}</mat-label>
            <mat-chip-list [required]='field.isRequired' #chipList aria-label="Tag selection">
              <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                (removed)="remove(tag)">
                {{tag}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
              <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="add($event)">
            </mat-chip-list>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
              <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                {{tag}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field *ngIf="field.fieldName != 'Tags'">
            <mat-label>{{ field.fieldName }}</mat-label>
            <mat-select [required]='field.isRequired' multiple [ngModel]="getMultiddlSelectedVal(field.fieldName)"
              formControlName="{{ field.fieldName }}" [disabled]="field.rolePermission==1">
              <mat-option *ngFor="let muldrp of getMuldropdownlist(field.fieldName)" [value]="muldrp">
                {{ muldrp }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>


        <ng-container *ngSwitchCase="'Checkbox'">
          <div class="checkList">
            <mat-label>{{ field.fieldName }}</mat-label>

            <div class="allCheckList" *ngFor="let chk of getCheckBoxlist(field.fieldName)">
              <mat-checkbox color="primary" [disabled]="field.rolePermission==1"
                [checked]="isChecked(field.fieldName, chk)" (change)="OnChange($event, chk, field.fieldID)">
                {{ chk }}
              </mat-checkbox>
            </div>
          </div>
        </ng-container>

      </div>
    </ng-container>
   

   </form>

    </div>

    <div class="allheaders" *ngIf="isAISearch==true">
      
      <div class="d-flex">
        
          <mat-form-field>                
            <mat-label>Search Keywords</mat-label>
            <input matInput placeholder="Search Keywords" [(ngModel)]="aisearchkeywords">
          </mat-form-field>
                   
         
      </div>
          

   <div class="d-flex">
    <div class="w5">

      <mat-form-field class="example-full-width" appearance="">
        <mat-label>Choose from date</mat-label>
        <input matInput [matDatepicker]="picker1" [(ngModel)]="fromDate" readonly>
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
     
    </div>
          
      
    <div class="w5">

      <mat-form-field class="example-full-width" appearance="">
        <mat-label>Choose to date</mat-label>
        <input matInput [matDatepicker]="picker2" 
          [(ngModel)]="toDate" readonly>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
     
    </div>
   </div>

     
    </div>

  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-flat-button class="calltoaction" type="submit"             
    (click)="searchAdvFilter(myFormGroup.value)" color="primary">
       Search
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>

</ng-template>


<ng-template #documentCategory>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>folder</mat-icon></span>
    Select Document Category
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </h2>
  <mat-dialog-content class="mat-typography" style="min-height:80px">
    <mat-form-field>
      <mat-select placeholder="Select Document Category" (selectionChange)="selectDocumentCategory($event)" [(ngModel)]="selecteddocumentCategory">
        <mat-option *ngFor="let documentCate of documentCategoryList;" [value]="documentCate.id">
          {{documentCate.description}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <!-- <button mat-flat-button color="primary" (click)="UploadDocumenttoPCC()">
      Upload
    </button> -->

  </mat-dialog-actions>
</ng-template>

<ng-template #selectAITemplate>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Attach AI Automation Template to {{selectedFolderName}}.
    <button mat-icon-button (click)="closeAIAutomationTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <div class="template-holder">
    <div class="left">

      <mat-form-field appearance="fill">
        <mat-label>Select Category</mat-label>
        <mat-select value="My Template">
          <mat-option value="My Template">My Template</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="list" #categoryList>
        <ul>
          <li (click)="getAIAutomationCategoryForImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }">All
          </li>
          <!-- <ng-container *ngFor="let stat of filteredTempCategoryList; let i = index">
            <li (click)="getTaskListThroughCategoryForImport(stat.ocrTemplateCategoryID, i+1)"
              [ngClass]="{'active': currentIndex == i+1 }"> {{ stat.ocrTemplateCategoryName }}</li>
          </ng-container> -->
        </ul>

      </div>

    </div>
    <div class="right">

      <div class="list">

        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" width="100%">
            <tr>
              <th>Automation Template</th>
              <th>Field Template</th>
              <th>Question Template</th>
              <th class="actBtn">Action</th>
            </tr>
            <tr *ngFor="let template of aITemplateList"
              [ngClass]="{ 'active': template.aiAutomationTemplateID === aiAutomationTemplateID}"
              [ngStyle]="{ 'background-color': template.aiAutomationTemplateID === aiAutomationTemplateID ? '#e8f0fe' : 'transparent' }">

              <td class="formName">
                {{template.name}}
              </td>

              <td class="formName">
                {{template.fieldTemplateName}}
              </td>
              <td class="formName">
                {{template.promptTemplateName}}
              </td>
              <td>
                <button mat-stroked-button color="primary" (click)="SelectAITemplate(template)">Select</button>
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFoundAITemplates" class="noRecordFound">No Record Found</div>
        </div>

      </div>

    </div>
  </div>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeAIAutomationTemplate()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="aiAutomationTemplateID!=0"
    (click)="attachAIAutomationTemplate()">
      Attach
    </button>
  </mat-dialog-actions>


</ng-template>


<ng-template #mergePDFs>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Merge PDF into {{documentName}} Document
    <button mat-icon-button (click)="closeMergPDF()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
 
  <div>

    <input #Input hidden="true" type="file" multiple (change)="selectFilesFromDragZoneForAddDoc($event)">
    <button class="upload_file_btn" mat-flat-button (click)="Input.click()">
      <mat-icon>upload_file</mat-icon> Upload File
    </button>

    <div cdkDropList class="fileHolder" (cdkDropListDropped)="drop($event)">
      <div class="example-box" *ngFor="let file of UploadedFiles; let i = index" cdkDrag>
        <ng-container>

          <div class="example-custom-placeholder" *cdkDragPlaceholder></div>

          <mat-card class="fileCont">
            <div class="DragIcon" cdkDragHandle>
              <mat-icon>drag_indicator</mat-icon>
            </div>

            <div class="Icon" *ngIf="file.documentType == 'pdf' || file.documentType == '.pdf' || file.documentType == 'PDF'">            
              <app-doc-icons  [iconType]="'PDF'"></app-doc-icons>
            </div>

            <!-- <div class="Icon"
              *ngIf="file.documentType == 'pdf' || file.documentType == '.pdf' || file.documentType == 'PDF'">
              <img src="../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
            </div> -->

            <div class="nameInfo">
              <h2>{{ file.fileName }}</h2>
              <p>{{ file.Totalsize }}</p>
              <p *ngIf="file.pageCount">Pages: {{ file.pageCount }}</p>
            </div>

            <div class="docAct">
              <button (click)="deleteFileFromUploaded(file,i)" mat-icon-button color="basic" matTooltipClass="tooltip"
                matTooltip="Delete">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>

          </mat-card>

        </ng-container>
      </div>
    </div>


    <div class="newDoc">
      <mat-slide-toggle *ngIf="UploadedFiles.length>0" color="primary" (change)="isNewToggle($event)">
        Save as a new document
      </mat-slide-toggle>


      Total Pages: {{totalPDFPages}}

    </div>

    <mat-form-field class="m10" *ngIf="IsNew==true">
      <mat-label>Document Name</mat-label>
      <input matInput maxlength="100" placeholder="add document name" [(ngModel)]="documentNames" />
    </mat-form-field>


  </div>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">

    <div *ngIf="totalPDFPages>200" style="color: red;">
      We recommend limiting the merged document to 200 pages to prevent potential feature malfunctions.
    </div>

    <!-- <button mat-button color="basic" (click)="closeMergPDF()">Cancel</button> -->
    <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="UploadedFiles.length>0"
      (click)="mergePdf()">
      Merge
    </button>
  </mat-dialog-actions>

  <br>
  <br>
  <div *ngIf="MergedFileHistoryList.length>0">
    <p>Uploaded File History</p>
   
    <div class="alldocs">
      <div class="example-box " *ngFor="let file of MergedFileHistoryList; let i = index">
      
        <ng-container>
         
          <mat-card class="fileConts">         
  
            <div class="Icon" *ngIf="file.fileType == 'pdf' || file.fileType == '.pdf' || file.fileType == 'PDF'">            
              <app-doc-icons  [iconType]="'PDF'"></app-doc-icons>
            </div>
           
            <div class="nameInfo">
              <h2>{{ file.name }}</h2>
              <p>{{ file.fileSize }}</p>           
            </div>
           
          </mat-card>
  
        </ng-container>
      </div>
    
    </div>    
  </div>
  

</ng-template>

<app-loader></app-loader>

